export default __webpack_public_path__ + "static/media/community-blue-icon.115e50b9.svg";